import {
  anonGetOneUser,
  createUser,
  deleteUser,
  deleteUsers,
  editUser,
  getUserById,
  getUsers,
  searchUsers,
  usersClientSearch,
  usersCSValidate,
  usersCSVCreate,
  usersTemplateCSVGet,
} from '../../../data/repositories/users/UsersRepository'

export async function getAllUsers(queryString: string) {
  return await getUsers(queryString)
}

export async function getSpecificUser(id: string) {
  return await getUserById(id)
}

export async function clientSearch(skip: number, limit?: number, key?: string) {
  return await usersClientSearch(skip, limit, key)
}

export async function adminCreateUser(
  name: string,
  emailOrPhone: string,
  roleIds: string[],
  projectIds: string[],
  levelIds: string[],
  pointOfContactId?: string | null,
  contractorId?: string | null,
) {
  return await createUser(emailOrPhone, name, roleIds, projectIds, levelIds, pointOfContactId, contractorId)
}

export async function adminEditUser(
  userId: string,
  name: string,
  emailOrPhone: string,
  roleIds: string[],
  projectIds: string[],
  levelIds: string[],
  pointOfContactId?: string | null,
  contractorId?: string | null,
) {
  return await editUser(userId, name, emailOrPhone, roleIds, projectIds, levelIds, pointOfContactId, contractorId)
}

export async function adminDeleteUser(userId: string) {
  return await deleteUser(userId)
}

export async function adminDeleteUsers(userIds: string[]) {
  return await deleteUsers(userIds)
}

export async function usersSearch(skip: number, limit?: number, key?: string) {
  return await searchUsers(skip, limit, key)
}

export async function anonGetUser(orgId: string, userID: string) {
  return await anonGetOneUser(orgId, userID)
}

export async function uploadUsersCSVFile(csvFile: File) {
  return await usersCSVCreate(csvFile)
}

export async function validateUsersCSVFile(csvFile: File) {
  return await usersCSValidate(csvFile)
}

export async function getUsersTemplateCSV() {
  return await usersTemplateCSVGet()
}
